export default __webpack_public_path__ + "static/media/login_desc_bg.b98cced2.jpg";